/*
 * -----------------------------------------------------------------------
 *  <copyright file="organization-grid/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { useGridCells, useTranslation } from 'hooks';
import ExpandableGrid from 'views/components/core/expandable/grid';

import './styles.scss';

const OrganizationGrid = ({ data, actions }: any) => {
    const { t } = useTranslation();
    const { MaxLengthCell, StandardCell, DateCell } = useGridCells();

    return (
        <ExpandableGrid
            customKey="studies-grid"
            id="studiesGrid"
            key="studiesGrid"
            items={data}
            rowActions={actions}
            groupable={false}
            showPager
            scrollable="scrollable"
            reorderable
            addScroll
            pageable={false}
            resizable
            options={{
                allowExcelExport: false,
                allowExpandCollapseAll: false,
                useFilterChips: false,
            }}
            detail={null}
            columns={[
                {
                    field: 'name',
                    id: 'system-organizations-name',
                    label: t('admin:organization'),
                    minWidth: 190,
                    lockedByDefault: true,
                    headerClass: 'border',
                    cells: { data: MaxLengthCell(150) },
                },
                {
                    field: 'loginCode',
                    id: 'system-organizations-loginCode',
                    label: t('admin:URLPath'),
                    minWidth: 160,
                    headerClass: 'border',
                    cells: { data: MaxLengthCell(20) },
                },
                {
                    field: '_mongoRegion',
                    id: 'system-organizations-DBRegion',
                    label: t('admin:DBRegion'),
                    minWidth: 200,
                    headerClass: 'border',
                    cells: { data: StandardCell() },
                },
                {
                    label: t('ra:createdBy'),
                    field: '_createdByString',
                    minWidth: 200,
                },
                {
                    label: t('ra:createdDate'),
                    field: 'created',
                    minWidth: 200,
                    cells: { data: DateCell },
                    filter: 'date',
                },
                {
                    label: t('ra:updatedBy'),
                    field: '_updatedByString',
                    minWidth: 220,
                },
                {
                    label: t('ra:updatedDate'),
                    field: 'updated',
                    minWidth: 210,
                    cells: { data: DateCell },
                    filter: 'date',
                },
                /*
                {
                    field: 'connectionString',
                    id: 'system-organizations-connection-string',
                    label: t('admin:connectionString'),
                    minWidth: 240,
                    cells: { data: MaxLengthCell(150) },
                    headerClass: 'border',
                    showByDefault: false
                },
                {
                    field: 'useTransaction',
                    id: 'system-organizations-use-transaction',
                    label: t('admin:useTransactions'),
                    minWidth: 200,
                    headerClass: 'border',
                    cells: { data: YesNoCell },
                    filterUi: GridColumnMenuActiveFilter,
                    showByDefault: false
                }
                */
            ]}
        />
    );
};

export default OrganizationGrid;
